module.exports = __webpack_public_path__ + "static/media/noticias-celular-iconos.e3a24c57.png";